import script from "./ContentEditableTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentEditableTooltip.vue?vue&type=script&setup=true&lang=js"

import "./ContentEditableTooltip.vue?vue&type=style&index=0&id=4bcee2fb&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bcee2fb"]])

export default __exports__